// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + (chunkId === 722 ? "code-editor" : chunkId) + ".min.js";
};